import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

export const Main: React.FC<BoxProps> = props => {
  return (
    <Box
      use="main"
      css={{ flex: 1, flexBasis: 'auto', width: '100%' }}
      {...props}
    />
  );
};

export default Main;
